import classNames from 'classnames';
import styles from './SearchField.module.scss';
import { UI_Button } from 'ui/components/1-atoms/Action/Button/Button';
import { UI_FormfieldString } from 'ui/components/2-molecules/Form/FormfieldString/FormfieldString';

type State = {
	required?: boolean;
	disabled?: boolean;
	hasError?: boolean;
	isHidden?: boolean;
};

export interface SearchFieldProps {
	className?: string;
	buttonText: string;
	id: string;
	name: string;
	label?: string;
	placeholder?: string;
	register?: { (name: string, { required }: State) };
	state?: State;
	errorMessage?: string;
}

export const UI_SearchField = ({ className, buttonText, label, state, id, name, placeholder, register }: SearchFieldProps) => {
	const { disabled, hasError } = state ?? {};
	state.isHidden = true;
	return (
		<div className={classNames(styles.SearchField, className, { [styles.hasError]: hasError }, { [styles.isDisabled]: disabled })}>
			<div className={styles.SearchField_wrapper}>
				<UI_FormfieldString
					type="search"
					id={id}
					state={state}
					name={name}
					label={label}
					placeholder={placeholder}
					className={styles.SearchField_input}
					register={register}
				/>
				<UI_Button type="submit" style="primary" disabled={disabled}>
					{buttonText}
				</UI_Button>
			</div>
		</div>
	);
};
